import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { DateTimeInput } from "../components/DateTimeInput";

export function AddEditAnnouncementForm({
  isOpen,
  onClose,
  isEdit, // New prop to toggle mode
  description,
  dateFrom,
  dateTo,
  contentAnnouncement,
  files,
  setDescription,
  setDateFrom,
  setDateTo,
  setContentAnnouncement,
  setFiles,
  handleSubmitAnnouncement 
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!description || !dateFrom || !dateTo || !contentAnnouncement) {
      setErrorState(true);
      return;
    }
    handleSubmitAnnouncement(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setErrorState(false);
  };

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    if (fileList.length > 0 && !fileList[0].type.startsWith("image/")) {
      alert("Please select an image file.");
      return;
    }
    setFiles(fileList);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";
    if (fileList.length > 0 && !fileList[0].type.startsWith("image/")) {
      alert("Please select an image file.");
      return;
    }
    setFiles(fileList);
  };

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      {isOpen && (
        <div className="modal">
          <div className="popUp-header row">
            <div className="popUp-title">
              <h3 style={{ color: "#668fca" }}>{isEdit ? "Edit Announcement" : "Add Announcement"}</h3>
            </div>
            <div className="popUp-close">
              <CloseIcon onClick={handleClose} />
            </div>
          </div>
          <div className="popUp-body">
            <div className="popUp-item info-item column">
              <div className="info-item-label">Description</div>
              <div className="info-item-input">
                <input placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} />
              </div>
              <span style={{ visibility: !description && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
            </div>
            <div className="popUp-item info-item column">
              <div className="info-item-label">Date From</div>
              <div className="info-item-input"><DateTimeInput date={dateFrom} setDate={setDateFrom} /></div>
              <span style={{ visibility: !dateFrom && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
            </div>
            <div className="popUp-item info-item column">
              <div className="info-item-label">Date To</div>
              <div className="info-item-input"><DateTimeInput date={dateTo} setDate={setDateTo} /></div>
              <span style={{ visibility: !dateTo && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
            </div>
            <div className="popUp-item info-item column">
              <div className="info-item-label">Content</div>
              <div className="info-item-input">
                <textarea style={{ width: "95%", minHeight: "100px", borderRadius: "3px", border: "1px solid #80808080", color: "rgb(104, 104, 104)" }}
                  value={contentAnnouncement} onChange={(e) => setContentAnnouncement(e.target.value)} />
              </div>
              <span style={{ visibility: !contentAnnouncement && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>Please fill up this field</span>
            </div>
            <div className="popUp-item info-item column">
              <div className="info-item-label">Upload</div>
              <div className="info-item-input">
                <label htmlFor="fileInput" className='browse'>Browse...</label>
                <input type="file" id="fileInput" onChange={handleBrowse} style={{ display: 'none' }} />
                {files.length > 0 ? (
                  <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                    <ul>{files.map((file, i) => <img key={i} src={file instanceof File ? URL.createObjectURL(file) : `data:image/jpeg;base64,${file}`} alt="" style={{ width: "150px" }} />)}</ul>
                    <div className="buttons row" style={{ justifyContent: "end" }}>
                      <button className="cancel row" onClick={() => setFiles([])}>CLEAR</button>
                    </div>
                  </div>
                ) : (
                  <div onDrop={handleDrop} onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.backgroundColor = "#bdbdbd7d"; }} onDragLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                    style={{ border: '2px dashed #ccc', borderRadius: '5px', padding: '20px', marginTop: '10px', textAlign: 'center' }}>Drop files here</div>
                )}
              </div>
            </div>
          </div>
          <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
            <button className="save row" onClick={submit}>SAVE</button>
          </div>
        </div>
      )}
    </div>
  );
}